<template>
    <div class="stadium-search">
        <div class="content">
            <div class="city">
                <a-icon type="environment" :style="{ fontSize: '16px','line-height':'100px' }" />
                <div class="my-warp">
                    <span class="my-province">
                        <a-select default-value="重庆" v-model="province"  size="large" :show-arrow="false" style="width: 140px;" @change="hadleProvince">
                            <a-select-option :value="item.value" v-for="item in address" :key="item.label" style="width: 140px;">
                                {{item.label}}
                            </a-select-option>
                        </a-select>
                        <span class="arrows"></span>
                    </span>
                    <span class="my-city">
                        <a-select default-value="不限"  v-model="city" size="large" style="width: 140px;margin-left: 10px;margin-right: 5px;" @change="hadleCity">
                        <a-select-option :value="item.value" v-for="item in cityList" :key="item.label">
                            {{item.label}}
                        </a-select-option>
                    </a-select>
                    <a-select default-value="不限" v-model="county"  size="large" style="width: 140px;" @change="hadleCounty">
                        <a-select-option  :value="item.value" v-for="item in countyList" :key="item.label">
                            {{item.label}}
                        </a-select-option>
                    </a-select>
                    </span>
                </div>
            </div>
            <div class="search">
                <a-input ref="userNameInput" v-model="keywords" placeholder="输入场馆查询" size="large" style="width: 300px;">
                    <a-icon slot="prefix" type="search" :style="{ fontSize: '18px',color:'#999999'}"/>
                </a-input>
                <span class="search-btn">搜索</span>
                <span class="check-in">场馆入住</span>
            </div>
        </div>
    </div>
</template>

<script>
import address from '@comm/utils/address.js'
export default {
  data () {
    return {
      address,
      province: '重庆',
      city:'不限',
      county: '不限',
      cityList: [
        {
          'value': '-1',
          'label': '不限',
        },
        {
          'value': '500100',
          'label': '重庆市市辖区',
          'children': [
            {
              'value': '500101',
              'label': '万州区'
            },
            {
              'value': '500102',
              'label': '涪陵区'
            },
            {
              'value': '500103',
              'label': '渝中区'
            },
            {
              'value': '500104',
              'label': '大渡口区'
            },
            {
              'value': '500105',
              'label': '江北区'
            },
            {
              'value': '500106',
              'label': '沙坪坝区'
            },
            {
              'value': '500107',
              'label': '九龙坡区'
            },
            {
              'value': '500108',
              'label': '南岸区'
            },
            {
              'value': '500109',
              'label': '北碚区'
            },
            {
              'value': '500110',
              'label': '綦江区'
            },
            {
              'value': '500111',
              'label': '大足区'
            },
            {
              'value': '500112',
              'label': '渝北区'
            },
            {
              'value': '500113',
              'label': '巴南区'
            },
            {
              'value': '500114',
              'label': '黔江区'
            },
            {
              'value': '500115',
              'label': '长寿区'
            },
            {
              'value': '500116',
              'label': '江津区'
            },
            {
              'value': '500117',
              'label': '合川区'
            },
            {
              'value': '500118',
              'label': '永川区'
            },
            {
              'value': '500119',
              'label': '南川区'
            },
            {
              'value': '500120',
              'label': '璧山区'
            },
            {
              'value': '500151',
              'label': '铜梁区'
            },
            {
              'value': '500152',
              'label': '潼南区'
            },
            {
              'value': '500153',
              'label': '荣昌区'
            },
            {
              'value': '500154',
              'label': '开州区'
            },
            {
              'value': '500155',
              'label': '梁平区'
            },
            {
              'value': '500156',
              'label': '武隆区'
            },
            {
              'value': '500191',
              'label': '高新区'
            },
            {
              'value': '500192',
              'label': '两江新区'
            },
            {
              'value': '500193',
              'label': '经开区'
            }
          ]
        },
        {
          'value': '500200',
          'label': '重庆市郊县',
          'children': [
            {
              'value': '500229',
              'label': '城口县'
            },
            {
              'value': '500230',
              'label': '丰都县'
            },
            {
              'value': '500231',
              'label': '垫江县'
            },
            {
              'value': '500233',
              'label': '忠县'
            },
            {
              'value': '500235',
              'label': '云阳县'
            },
            {
              'value': '500236',
              'label': '奉节县'
            },
            {
              'value': '500237',
              'label': '巫山县'
            },
            {
              'value': '500238',
              'label': '巫溪县'
            },
            {
              'value': '500240',
              'label': '石柱土家族自治县'
            },
            {
              'value': '500241',
              'label': '秀山土家族苗族自治县'
            },
            {
              'value': '500242',
              'label': '酉阳土家族苗族自治县'
            },
            {
              'value': '500243',
              'label': '彭水苗族土家族自治县'
            }
          ]
        }
      ],//城市列表
      countyList:[],//县城列表
      keywords:''
    }
  },
  mounted () {

  },
  methods: {

    hadleProvince (province) {
      this.province = province
      this.address.forEach(item => {
        if (item.value == province) {
          this.cityList = item.children
        }  
      })
      this.city = '不限'
      this.county = '不限'
    },
    hadleCity (city) {
      this.cityList.forEach(item => {
        if (item.value == city) {
          this.countyList = item.children
          this.city=item.label
        }
      })
      this.county = '不限'
    },
    hadleCounty (county) {
      this.countyList.forEach(item => {
        if (item.value == county) {
          this.county=item.label
        }
      })
    }
  },

}
</script>

<style lang="scss" scoped>
.stadium-search{
    width: 100%;
    height: 100px;
    background-color: #ffffff;
    .content{
        width: 1200px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        line-height: 100px;
        .city{
            width: 600px;    
            display: flex;
            justify-content: flex-start;
            .my-warp{
                /deep/ .ant-select-selection{
                    border: none !important;
                    outline: none;
                }
                /deep/ .ant-select-selection:focus{
                    border-color: transparent !important;
                    box-shadow: none;
                    outline: none;
                }
                //去掉选择的边框
                /deep/ .ant-select-focused .ant-select-selection,
                .ant-select-selection:focus,
                .ant-select-selection:active{
                    box-shadow: none;
                    outline: none;
                }
                .my-province{
                    display: inline-block;
                    position: relative;
                    /deep/ .ant-select-selection .ant-select-selection__rendered{   
                        font-weight: bold;
                        text-align: center;
                    }
                    .arrows{
                        position: absolute;
                        display: inline-block;
                        width: 0;
                        height: 0;
                        border: 5px solid #000;               
                        border-bottom-color: transparent;
                        border-left-color: transparent;
                        border-right-color: transparent;
                        top: 50%;
                        transform: translateY(-2px);
                        right:0;
                    }
                }
                .my-city{
                    /deep/ .ant-select-selection{
                        border: none !important;
                        background-color: #E8E8E8;
                        height: 54px;
                        line-height: 54px;
                    }
                    /deep/ .ant-select-selection .ant-select-selection__rendered{
                        border: none !important;
                        background-color: #E8E8E8;
                        height: 54px;
                        line-height: 54px;
                        font-weight: bold;
                    }
                   
                }
               
            }        
        }
        .search{
            display: flex;
            align-items: center;
            justify-content: flex-end;
            width: 800px;
            .search-btn{
                display: inline-block;
                width: 120px;
                height: 54px;
                line-height: 54px;
                color: #ffffff;
                text-align: center;
                background-color: #B01F23;
                cursor: pointer;
                margin-right: 20px;
                font-size: 18px;
            }
            .search-btn:hover{
                opacity: 0.8;
            }
            .check-in{
                display: inline-block;
                width: 120px;
                height: 54px;
                line-height: 54px;
                color: #ffffff;
                text-align: center;
                background: #CACACA;
                cursor: pointer;
                font-size: 18px;
            }
            .check-in:hover{
                opacity: 0.8;
            }
        }
    }
}
/deep/ .ant-input{
    height: 54px;
    line-height: 54px;
    background-color: #E8E8E8;
    //输入光标颜色
    // caret-color:#B01F23;
    &:focus{
        border-color: #B01F23 !important;
        box-shadow:none;
    }
    &:focus-within{
        border-color: #B01F23 !important;
    }
    &:hover{
        border-color: #B01F23 !important;
    }
    &::selection{
        background-color: #CACACA !important;
    } 
}

.ant-dropdown-link{
    display: inline-block;
    width: 40px;
    text-align: center;
    position: relative;
    margin-right: 20px;
    font-weight: bold;
    cursor: pointer;

}
</style>


// WEBPACK FOOTER //
// src/daoba-match/views/stadium/components/home/Search.vue